import { render, staticRenderFns } from "./AddProfilePage.vue?vue&type=template&id=2821f6a8&scoped=true"
import script from "./AddProfilePage.vue?vue&type=script&lang=js"
export * from "./AddProfilePage.vue?vue&type=script&lang=js"
import style0 from "./AddProfilePage.vue?vue&type=style&index=0&id=2821f6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821f6a8",
  null
  
)

export default component.exports